export const NAVIGATION_TABS = {
  CONTRACTS: 'contracts',
  RESEARCH: 'research',
  METHODOLOGY: 'methodology',
  RULES: 'rules',
  CHARTS: 'charts',
  HISTORY: 'history',
  DISCUSSION: 'discussion',
  LINKS: 'links',
};

export default NAVIGATION_TABS;



// WEBPACK FOOTER //
// ./src/components/pages/page-market-detail-sushi/navigation-tabs.js